export default {
  aggregates: {
    aggregated: 'Zagregowane wyniki',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'temu',
    from: 'od',
    since: 'do',
    unit: {
      DAY: 'dzień|dni',
      MONTH: 'miesiąc|miesiące',
      YEAR: 'rok|lata'
    },
    untilNow: 'do teraz'
  },
  categoryDetails: {
    average: 'Średnia:',
    chartLabel: {
      noLabel: 'Nie',
      yesLabel: 'Tak'
    },
    description:
      'To pokazuje, jak rozkładają się odpowiedzi zespołu na wszystkie pytania w kategorii.',
    hideOwnAnswers: 'Ukryj własne odpowiedzi',
    noResponses: 'Brak odpowiedzi',
    notParticipating: 'Nie odpowiedziałeś(-aś) na te pytania.',
    numberOfPeople: 'Respondenci:',
    sensitiveQuestion: 'Widoczne tylko dla Ciebie jako menedżera.',
    showFollowUpQuestions: 'Pokaż pytania uzupełniające',
    toggleButton: {
      overview: 'Podsumowanie',
      questions: 'Pytania'
    },
    tooltip: {
      barValue: 'nikt | {count} os. | {count} os.',
      barValueAnswers: 'nikt | {count} odpowiedź | {count} odpowiedzi'
    },
    workWith: 'Popraw {categoryName}',
    yourResponse: 'Twoja odpowiedź:'
  },
  error: {
    couldNotLoadAggregates: 'Nie można załadować zagregowanych wyników.',
    couldNotLoadResults: 'Nie można załadować wyników.',
    networkError:
      'Wystąpił problem z ładowaniem danych przez internet. Czy twoje połączenie działa prawidłowo?',
    unknown: 'Wystąpił nieznany błąd'
  },
  errors: {
    status: {
      BadRequest: 'Nieprawidłowe żądanie do serwera',
      Forbidden: 'Nie ma dostępu do tego zasobu',
      InternalServerError:
        'Cos poszło nie tak na serwerze. Prosimy skontaktować się z działem wsparcia, jeśli błąd będzie nadal występować',
      NotFound: 'Nie udało się znaleźć tego, czego szukasz dla',
      Unauthorized: 'Nie masz uprawnień do dostępu do tego zasobu',
      UnknownError: 'Wystąpił nieznany błąd'
    }
  },
  freetext: {
    loadResponses: 'Załaduj odpowiedzi',
    noFreeTextQuestions:
      'Jeżeli w ankiecie pojawią się pytania w formie dowolnego tekstu, wszystkie odpowiedzi będą widoczne tutaj.',
    notEnoughResponses: 'Brak wystarczającej liczby odpowiedzi.',
    responses: 'Brak odpowiedzi |{count} odpowiedź | {count} odpowiedzi'
  },
  general: {
    add: 'Dodaj',
    cancel: 'Anuluj',
    entireOrganization: 'Cała organizacja',
    ok: 'OK'
  },
  groupsComparison: {
    averageForItem:
      '{value} to średnia wartość dla pytań w ramach {title}. {compareToBenchmark}',
    currentValue: 'Obecna wartość',
    filter: {
      findGroups: 'Znajdź grupy',
      shouldExportWithHierarchy: 'Włącz grupy podstawowe'
    },
    loadMore: 'Załaduj więcej',
    loadMoreInGroup: 'Załaduj więcej z {groupName}',
    noone: 'Nikt nie odpowiedział',
    noResults:
      'Ta grupa nie ma jeszcze wystarczającej liczby odpowiedzi. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'odpowiedziało',
    nps: 'Odsetek promotorów netto',
    nps_detractors: 'Krytycy',
    nps_passives: 'Pasywni',
    nps_promoters: 'Promotorzy',
    questions: 'Pytania w kategorii',
    showTrend: 'Pokaż zmianę',
    violationsIn:
      'Zgłoszono, że w grupie {groupName} pojawiły się naruszenia. Skontaktuj się z działem HR, który przekaże więcej informacji i pomoże Ci przepracować ten problem w przyszłości.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: 'Wybierz datę jako punkt początkowy dla historii.',
      selectDate: 'Wyświetlałoby historię ankiet od {date}.',
      selectedDate: 'Wyświetla historię ankiet od {date}.'
    },
    selectorOptions: {
      custom: 'dostosuj',
      oneMonth: '1m',
      oneYear: '12m',
      sixMonths: '6m'
    }
  },
  loading: {
    error: {
      link: 'Spróbuj ponownie'
    }
  },
  navbar: {
    administration: 'Administrator',
    currentSurveys: 'Aktualne ankiety',
    help: 'Pomoc',
    myActivities: 'Działania',
    ourResults: 'Wyniki',
    overview: 'Zestawienie',
    team: 'Zespół',
    welcome: 'Witamy'
  },
  page: {
    results: 'Wszystkie wyniki'
  },
  resultDetails: {
    backToResults: 'Powrót',
    exportData: 'Eksportu',
    exportModal: {
      includeSensitiveQuestions: 'Uwzględnij wrażliwe pytania',
      loadingMessage: 'Przygotowuję dane do wyeksportowania, poczekaj chwilę!',
      saveAsExcelAllGroupsDescription:
        'Eksportując do programu Excel, otrzymasz plik z wynikami dla {groupTitle} i wszystkich podstawowych grup... To dobre rozwiązanie, jeśli chcesz przeprowadzić własną analizę lub obliczenia dla kilku grup.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Eksportując do programu Excel, otrzymasz plik z wynikami dla {groupTitle}{segmentInfo}. To dobre rozwiązanie, jeśli chcesz przeprowadzić własną analizę lub obliczenia.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Otrzymasz dokument PDF z wynikami wszystkich kategorii i pytaniami dla wybranej grupy. To praktyczne rozwiązanie, jeśli chcesz wydrukować wyniki.',
      saveAsPowerPointButton: 'PowerPoint',
      saveAsPowerPointDescription:
        'Eksport do programu PowerPoint zapewni Ci ładną prezentację z wynikami dla {groupTitle}{segmentInfo}. To doskonałe rozwiązanie, jeśli chcesz zaprezentować wyniki innym osobom na dużym ekranie.'
    },
    notes: {
      draggable: {
        explanation: 'Widoczne tylko dla Ciebie',
        placeholder:
          'Wpisz tutaj własne notatki, komentarze i refleksje na temat ankiety',
        title: 'Notatki osobiste'
      },
      status: {
        initial: 'Automatyczne zapisywanie w trakcie pisania',
        saved: 'Zmiany zapisane!',
        unsaved: 'Zapisywanie wkrótce...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Nie ma wystarczającej liczby odpowiedzi, aby wyświetlić wyniki dla każdego użytkownika'
        },
        description: {
          high: 'Odpowiedziała jedna osoba, zatem jej średni wynik zmienił się na zielony.|Odpowiedziały(-o) {count} osoby/osób, zatem ich średni wynik zmienił się na zielony.',
          low: 'Odpowiedziała jedna osoba, zatem jej średni wynik zmienił się na czerwony.|Odpowiedziały(-o) {count} osoby/osób, zatem ich średni wynik zmienił się na czerwony.',
          medium:
            'Odpowiedziała jedna osoba, zatem jej średni wynik zmienił się na żółty.|Odpowiedziały {count} osoby, zatem ich średni wynik zmienił się na żółty.'
        },
        title: 'Nikt|Jedna osoba|{count} osoby/osób'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Twój wynik jest taki sam jak wynik Pulsᐩ benchmark® dla {title}.',
        higherThanBenchmarkValue:
          'Twój wynik jest o {benchmarkDiff} wyższy od wyniku Pulsᐩ benchmark® dla {title}, który wynosi {benchmarkValue}. Doskonale!',
        lowerThanBenchmarkValue:
          'Twój wynik jest o {benchmarkDiff} niższy niż Pulsᐩ benchmark® dla {title}, który wynosi {benchmarkValue}.',
        percentagePoints: 'Punkty procentowe'
      },
      enps: {
        button: {
          description:
            'Zostaniesz przekierowany do naszego partnera, firmy EQI, która gromadzi dane porównawcze dla wielu organizacji i udostępnia bardziej szczegółowy wgląd w Twój własny wynik eNPS.',
          title: 'Porównaj swój wynik eNPS z innymi organizacjami'
        }
      },
      toggleButton: {
        history: 'Historia',
        overview: 'Zestawienie'
      }
    }
  },
  results: {
    aggregated: 'Zbiorowe',
    chooseSurvey: 'Wybierz ankietę',
    finished: 'Ukończono',
    published: 'W toku'
  },
  resultsmessages: {
    disclaimer:
      'Pulsᐩ AI korzysta z generatywnej sztucznej inteligencji i może popełniać błędy.',
    error: {
      generic:
        'Coś nie działa zgodnie z oczekiwaniami. Spróbuj załadować stronę ponownie.',
      notEnoughResults:
        'Brak wyników do omówienia. Wybierz inną grupę lub ankietę, aby skorzystać z AI Pulsᐩ.'
    },
    moreInfo: 'Dowiedz się, jak używać AI Pulsᐩ jako lider',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Zadaj pytanie dotyczące wyników...',
    reload: 'Załaduj stronę ponownie',
    report: 'Zgłoś problem',
    send: 'Wyślij',
    suggestionHeader: 'Oto kilka propozycji pytań, które możesz zadać:',
    suggestions: {
      groupsComparison: {
        1: 'Na jakich grupach powinienem się skupić?',
        2: 'Czy jest jakieś pytanie, nad którymi powinna pracować większość grup?',
        3: 'Które grupy wykazują negatywne trendy?',
        4: 'Które grupy mają pozytywne trendy?',
        5: 'Które grupy wyróżniają się negatywnie?',
        6: 'Które grupy potrzebują mojej uwagi?',
        7: 'Co powinienem zrobić najpierw?'
      },
      overview: {
        1: 'Co powinienem zrobić z naszym wynikiem?',
        2: 'Jak należy zaprezentować wynik mojemu zespołowi?',
        3: 'Ogólnie rzecz biorąc, jak wyglądają wyniki?',
        4: 'Jakie 3 najważniejsze działania powinniśmy podjąć?',
        5: 'Jakie aspekty moich umiejętności przywódczych powinienem  ulepszyć?',
        6: 'Jakie ryzyka wiążą się z naszymi działaniami?',
        7: 'Co może się zdarzyć, jeśli nie wykonamy żadnych działań?',
        8: 'Co powinno być moimi priorytetami?',
        9: 'Jak wygląda prognoza dla mojego zespołu?'
      }
    },
    title: 'AI Pulsᐩ'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'Wszyscy'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Porównaj'
        },
        export: {
          title: 'Eksportuj'
        },
        freetext: {
          title: 'Dowolny tekst'
        },
        results: {
          title: 'Wyniki ankiety'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Nie można wyświetlić statystyk bez ryzyka utraty anonimowości.',
    others: 'Inna | Inne',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Administracja',
    currentSurveys: 'Aktualne ankiety',
    dashboard: 'Pulpit',
    help: 'Pomoc',
    logOut: 'Wyloguj',
    myActivities: 'Moje działania',
    ourResults: 'Nasze wyniki'
  },
  topbanner: {
    preview: {
      body: 'Oglądasz teraz nową wersję widoku wyników Pulsᐩ, która oferuje wiele ulepszeń! Jeśli napotkasz coś, co nie działa prawidłowo, lub chcesz podzielić się swoją opinią, daj nam znać. Jeżeli chcesz, możesz także wrócić do starej wersji.',
      header: 'Nowa wersja!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'W okresie {startDate} - {endDate} wynik zmniejszył się dla {categoryName}.',
        trend_increased:
          'W okresie {startDate} - {endDate} wynik został zwiększony dla {categoryName}. Kontynuuj dobrą pracę!',
        trend_same:
          'Wynik pozostał taki sam dla {categoryName} w okresie {startDate} - {endDate}.'
      }
    },
    noTrend: 'Nie ma ankiety, z którą można by porównać dane.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'W porównaniu z wcześniejszą ankietą z {oldSurveyDate} wynik dla: {tagName} spadł o {changeInPercent}%.',
        nps_trend_increased:
          'W porównaniu z wcześniejszą ankietą z {oldSurveyDate} wynik dla: {tagName} wzrósł o {changeInPercent}%.',
        nps_trend_same:
          'Od ostatniej ankiety z {oldSurveyDate} wynik dla {tagName} pozostał mniej więcej na tym samym poziomie ({changeInPercent}% zmiany).',
        trend_decreased:
          'W okresie {startDate} - {endDate} wynik zmniejszył się dla {tagName}.',
        trend_increased:
          'W okresie {startDate} - {endDate} wynik został zwiększony dla {tagName}',
        trend_same:
          'Wynik pozostał taki sam dla {categoryName} w okresie {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Wszystkie grupy',
    cannotChangeGroupsWhileComparing:
      'W widoku porównawczym patrzysz na kilka grup jednocześnie.',
    group: 'Grupa',
    segment: 'Segment',
    survey: 'Ankieta'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Liczba osób, które wybrały przynajmniej działanie',
      totalActions: 'Łączna liczba wybranych działań'
    },
    title: 'Podsumowanie działań'
  },
  widgetAlert: {
    actions: {
      saved: 'Dzięki, zapisano działanie.'
    },
    links: {
      tooltip: 'Link otworzy się w nowym oknie'
    },
    notEnoughData: 'W tej chwili nie ma nic do wyświetlenia.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Zgłoszone ostatnio {surveyDate}.'
      },
      question: {
        info: 'Zadane ostatnio {surveyDate} w „{surveyTitle}”.'
      }
    },
    notEnoughResponses:
      'Nie ma jeszcze wystarczającej ilości odpowiedzi, aby tu cokolwiek wyświetlić.',
    title: 'Kategorie',
    tooltip: {
      value:
        'To średnia wartość dla wszystkich odpowiedzi na pytanie spośród {categoryName}, których udzieliły osoby w grupie {groupName}.'
    }
  },
  widgetErrorFallback: {
    description:
      'Wystąpił nieoczekiwany błąd podczas próby załadowania widżetu. Spróbuj najpierw załadować stronę ponownie. Jeśli problem będzie nadal występować, prosimy zgłosić go nam, a natychmiast się nim zajmiemy!',
    hideErrorDetails: 'Ukryj szczegóły błędu',
    showErrorDetails: 'Pokaż szczegóły błędu',
    title: 'Problem z widżetem!'
  },
  widgetGroupActions: {
    allCategories: 'We wszystkich kategoriach',
    freeText: {
      alert: {
        noResults: 'Nic nie znaleziono. Spróbuj wpisać coś innego.',
        typeMore: 'Wpisz więcej'
      },
      filterField: {
        placeholder: 'Wpisz, aby znaleźć komentarze'
      },
      numberOfComments: '{numberOfComments} komentarzy'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title: 'Jak rozwijać odpowiedzialność osobistą wśród pracowników'
      }
    },
    noActions: 'Brak działań do wyświetlenia.',
    noActionsSelectedInCategory: 'Nie wybrano żadnych działań',
    otherActions: 'Własne działania',
    people: 'nikt | {count} os. | {count} os.',
    peopleSelectedActions:
      'Spośród {peopleResponded} osób, które udzieliły odpowiedzi, tylko 1 wybrała co najmniej jedno działanie ({percentage}%)| Spośród {peopleResponded} osób, które udzieliły odpowiedzi, {count} osób wybrało co najmniej jedno działanie ({percentage}%)',
    title: 'Wybrane działania dla osób z grupy {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 osoba wybrała to działanie| {count} osób wybrało to działanie'
    }
  },
  widgetGroupPriorities: {
    description:
      'To są najważniejsze obszary, na których należy się skupić, według uczestników ankiety.',
    freeTextResponses: 'Zobacz darmowe odpowiedzi tekstowe.',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Jak rozwijać swój zespół dzięki Pulsᐩ'
      }
    },
    noPriorities: 'Nie ma priorytetów wybranych przez uczestników.',
    people: 'nikt | {count} os. | {count} os.',
    thinkImportant:
      ' Wydaje się, że najważniejszą kategorią jest "{category}".',
    title: 'Priorytety dla osób w {groupName}.'
  },
  widgetNotImplemented: {
    content: 'Jeszcze nie wdrożone'
  },
  widgetSurveyInfo: {
    endDate: 'Data końcowa:',
    noone: 'Nikt nie odpowiedział',
    notEnoughResponses: {
      aggregate:
        'Liczba osób, które odpowiedziały w tym okresie, jest niewystarczająca, aby wyświetlić wyniki.',
      completed:
        'Liczba osób, które wzięły udział w ankiecie, jest niewystarczająca, aby wyświetlić wyniki.',
      published:
        'Liczba osób, które odpowiedziały na ankietę, jest jeszcze za mała, aby wyświetlić wyniki.'
    },
    participation: {
      title: 'Udział'
    },
    startDate: 'Data rozpoczęcia:',
    status: {
      completed: 'Ankieta zakończona! Oto wyniki końcowe.',
      published: 'Ankieta jeszcze się nie zakończyła. To wstępne wyniki.'
    },
    usersInvited: 'Zaproszone osoby:',
    usersResponded: 'Osoby, które odpowiedziały:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Oto najnowsze wyniki dla {groupName}.'
    },
    notEnoughResponses:
      'Nie ma jeszcze wystarczającej ilości odpowiedzi, aby tu cokolwiek wyświetlić.',
    title: {
      company: 'Całość {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS, czyli odsetek promotorów netto pracownika mierzy, jak skłonny jest pracownik do polecenia pracy w firmie, w której pracuje.',
      nps_description:
        'NPS, czyli odsetek promotorów netto to liczba mierząca prawdopodobieństwo, z jakim ludzie gotowi są polecić coś innym.',
      nps_detractors: 'Krytycy',
      nps_passives: 'Pasywni',
      nps_promoters: 'Promotorzy',
      value:
        'To średnia wartość dla wszystkich odpowiedzi na pytanie z etykietą {tagName}, których udzieliły osoby w grupie {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} na przestrzeni czasu',
    twoTags: '{tag1} i {tag2}'
  }
}
